var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"mb-1 text-center position-relative d-inline-block border-0",class:_vm.$style.glowyButton},Object.assign({}, _vm.$listeners)),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }